import {Dispatch, FC, SetStateAction} from 'react'
import {Modal} from 'react-bootstrap'
import {useLavanderia} from '../../../../../../../../hooks/useLavanderia'
import {TabLavanderiaModel} from '../../../../../../../../models'
interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
}

const ModalWarningPoint: FC<Props> = ({show, setShow}) => {
  const {currentTabItem, changeCurrentTabItem} = useLavanderia()
  const handleClose = () => {
    const obj: TabLavanderiaModel = {
      ...currentTabItem,
      currentExternalTab: 0,
    }
    changeCurrentTabItem(obj)
    setShow(false)
  }
  return (
    <Modal className='modal fade' show={show} dialogClassName='modal-md' aria-hidden='true'>
      <div className='modal-content'>
        <div className='modal-header justify-content-center'>
          <h5 className='modal-title'>Advertencia</h5>
        </div>
        <div className='modal-body'>
          <div className='row'>
            <div className='mb-2 col-12'>
              Debe registrar el punto de lavandería en el formulario
            </div>
            <div className='d-flex justify-content-center mb-3'>
              <button type='button' className='btn btn-light-primary me-5' onClick={handleClose}>
                Aceptar
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export {ModalWarningPoint}
